import { NextPage } from 'next';
import {
	Banner,
	Claims,
	ContainerBase,
	Faqs,
	// HowWorks,
	ReadyToGetBanner,
} from 'components/landing';
import { CookieBanner } from 'components/landing/cookieBanner';
import { Testimonials } from '@/components/landing/testimonials';

const HomePage: NextPage = () => {
	return (
		<div className='bg-[#FBFBFB] bg-[url("/img/landing/svg/hero/hero-bg-blur-mobile.svg")] xl:bg-[url("/img/landing/svg/hero/hero-bg-blur.svg")] bg-contain bg-no-repeat bg-[position:0px_-80px] 4xl:bg-[position:0px_-280px]'>
			<Banner />
			<Claims />
			{/* <HowWorks /> */}
			<Testimonials />
			<Faqs classNameDescription="!text-base md:!text-lg" />
			<ContainerBase>
				<ReadyToGetBanner classNameContainer="!max-w-full" />
			</ContainerBase>
			<CookieBanner />
		</div>
	);
};

export default HomePage;
